import React from 'react'

import PropTypes from 'prop-types'

import './rea-tag.css'

const ReaTag = (props) => {
  return (
    <div className={`rea-tag-container ${props.rootClassName} ${props.description ? 'rea-tag-has-desc' : ''}`}>
      <div className="rea-tag-body">
        <span className="rea-tag-title">{props.text}</span>
        {props.description && (
          <span className="rea-tag-description">{props.description}</span>
        )}
      </div>
      <img
        alt={props.pastedImageAlt1}
        src={props.pastedImageSrc1}
        className="rea-tag-pasted-image"
      />
    </div>
  )
}

ReaTag.defaultProps = {
  pastedImageSrc1: '/external/pastedimage-0qvq.svg',
  text: 'Sample Text',
  pastedImageAlt1: 'pastedImage',
  rootClassName: '',
  description: '',
}

ReaTag.propTypes = {
  pastedImageSrc1: PropTypes.string,
  text: PropTypes.string,
  pastedImageAlt1: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default ReaTag
